module.exports = __webpack_public_path__ + "static/media/food-truck-corporate-background.e3f63a3c.jpg";